import { defineMessages } from 'react-intl';

export default defineMessages({
    accountTitle: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.view.Account:',
        defaultMessage: 'Account:',
    },
    wc7WorkersComp: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.view.Workers Compensation Quote With QuoteID',
        defaultMessage: "Workers' Compensation Quote ({quoteNumber})",
    },
    commercialProperty: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.view.Commercial Quote With QuoteID',
        defaultMessage: 'Commercial - Quote ({quoteNumber})',
    },
    personalAuto: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.view.PersonalAuto Quote With QuoteID',
        defaultMessage: 'Personal Auto Quote ({quoteNumber})',
    },
    businessOwners: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.view.BusinessOwners Quote With QuoteID',
        defaultMessage: 'Business Owners Quote  ({quoteNumber})',
    },
    homeowners: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.view.HomeOwners Quote With QuoteID',
        defaultMessage: 'Residential - Quote ({quoteNumber})', // Fix for DE15916 
    },
    hopHomeowners: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.view.HOPHomeOwners Quote With QuoteID',
        defaultMessage: 'Home Owners Quote ({quoteNumber})',
    },
    homeownersPolicyChange: {
        id: 'endorsement.directives.templates.bank-account-details-quote.view.Policy Changes - Homeowners',
        defaultMessage: 'Policy Changes - ({quoteNumber})',
    },
    homeownersPolicyChangePolicyType: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.view.res.Policy Changes - Homeowners Policy Type',
        defaultMessage:
            '{policyType} ({quoteNumber}) - Policy Change ({jobId})',
    },
    hopHomeownersPolicyChange: {
        id: 'endorsement.directives.templates.bank-account-details-quote.view.Policy Changes - HOPHomeowners',
        defaultMessage: 'Policy Changes - ({quoteNumber})',
    },
    businessOwnersPolicyChange: {
        id: 'endorsement.directives.templates.bop.view.Policy Changes - Business Owners',
        defaultMessage: 'Business Owners {quoteNumber} - Policy Change {jobId}',
    },
    businessOwnersRenewal: {
        id: 'endorsement.directives.templates.bop.view.Policy Renewal - Business Owners',
        defaultMessage: 'Businessowners {quoteNumber} - Renewal {jobId}',
    },
    commercialPropertyPolicyChange: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.view.Policy Changes - Commercial Property',
        defaultMessage:
            'Commercial Property {quoteNumber} - Policy Change {jobId}',
    },
    commercialPropertyRenewal: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.view.Policy Renewal - Commercial Property',
        defaultMessage: 'Commercial Property ({quoteNumber}) - Renewal ({jobId})',
    },
    commercialPropertyRenewalPolicyType: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.view.Policy Renewal - Commercial Property Policy Type',
        defaultMessage: '{policyType} ({quoteNumber}) - Renewal ({jobId})',
    },
    commercialPropertyPolicyChangePolicyType: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.view.Policy Changes - Commercial Property Policy Type',
        defaultMessage:
            '{policyType} ({quoteNumber}) - Policy Change ({jobId})',
    },
    personalAutoPolicyChange: {
        id: 'endorsement.directives.templates.pa.view.Policy Changes - Personal Auto',
        defaultMessage: 'Policy Changes - ({quoteNumber})',
    },
    fnolNewClaim: {
        id: 'fnol.common.views.fnol.view.New Claim',
        defaultMessage: 'New Claim',
    },
    wizardCancelTitle: {
        id: 'portal.components.wizard.title',
        defaultMessage: 'Are you sure you want to exit?'
    },
    wizardQuoteCancelDescription: {
        id: 'portal.components.quoteWizard.cancelDescription',
        defaultMessage: 'The information you entered will be stored as a draft quote. You must complete and submit this quote within 30 days of its Effective Date, or it will expire.'
    },
    wizardDraftRenewalExitDescriptionHO: {
        id: 'quoteandbind.renewalWizard.residential.TWIA.Modal.Draft.cancelDescription',
        defaultMessage: 'The renewal for policy {policyNumber} is in draft status. Please review and quote renewal changes. If the changes are not quoted prior to the renewal offer date, all changes will be lost, and the offer will be generated based on the expiring policy.',
    },
    wizardQuotedRenewalExitDescriptionHO: {
        id: 'quoteandbind.renewalWizard.residential.TWIA.Modal.Quoted.cancelDescription',
        defaultMessage: 'The renewal for policy {policyNumber} is in quoted status. All quoted changes will be included in the renewal offer.',
    },
    wizardRenewingRenewalExitDescriptionHO: {
        id: 'quoteandbind.renewalWizard.residential.TWIA.Modal.Renewing.cancelDescription',
        defaultMessage: 'The renewal for policy {policyNumber} is scheduled for a renewal.',
    },
    wizardDraftRenewalExitDescriptionCP: {
        id: 'quoteandbind.renewalWizard.commercial.TWIA.Modal.Draft.cancelDescription',
        defaultMessage: 'The renewal for policy {policyNumber} is in draft status. If you exit without proceeding to the Payment Details screen and selecting either Save & Exit or Submit, the renewal on this policy will not be processed.',
    },
    wizardQuotedRenewalExitDescriptionCP: {
        id: 'quoteandbind.renewalWizard.commercial.TWIA.Modal.Quoted.cancelDescription',
        defaultMessage: 'The renewal for policy {policyNumber} is in quoted status. If you exit without proceeding to the Payment Details screen and selecting either Save & Exit or Submit, the renewal on this policy will not be processed.',
    },
    wizardRenewingRenewalExitDescriptionCP: {
        id: 'quoteandbind.renewalWizard.commercial.TWIA.Modal.Renewing.cancelDescription',
        defaultMessage: 'The renewal for policy {policyNumber} is scheduled for a renewal.',
    },
    policyChangeCancelMessage: {
        id: "quoteandbind.wizard.commercial.TFPA.Modal.Policy",
        defaultMessage: "The information you entered will be saved as a draft. You must complete and submit this transaction within 30 days of its Effective Date, or it will expire."
    },
    cancelButtonMsg: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.cancelButtonMsg',
        defaultMessage: 'No'
    },
    confirmButtonMsg: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.confirmButtonMsg',
        defaultMessage: 'Yes'
    },
});
